import { formatAmount } from 'common/formatAmount';

export const getFormattedExchangeRate: ({
  rate,
  sourceCurrency,
  targetCurrency,
}: {
  rate: number;
  sourceCurrency: string;
  targetCurrency: string;
}) => string = ({ rate, sourceCurrency, targetCurrency }) => {
  const formattedSourceAmountToRate = formatAmount({
    currency: sourceCurrency,
    currencyDisplay: 'code',
    forcePlusSign: false,
    value: 1,
  });

  const formattedTargetAmountToRate = formatAmount({
    currency: targetCurrency,
    currencyDisplay: 'code',
    forcePlusSign: false,
    isExchangeRate: true,
    value: rate,
  });

  return `${formattedSourceAmountToRate} = ${formattedTargetAmountToRate}`;
};
